import { useParams, useSearchParams } from 'react-router-dom';
import {
  useBootstrapSelector,
  useUserSettingsSelector,
} from '../../../redux/selectorHooks';
import { useMemo } from 'react';

/**
 * @returns default Builder schemaId by priority and if it is active
 * 1. if exists and active => schemaId from search params
 * 2. if exists and active, activeSchemaId from old builder slice
 * 3. default users schemaId if active
 * 4. if none of the above are active return first active
 * 6. if there is no active schema will return undefined
 */

const useOptionalDefaultSchemaId = () => {
  const pathParams = useParams();
  const [searchParams] = useSearchParams();
  const schemaConfig = useBootstrapSelector('schemaConfig');

  const schemaIdFromUrl = pathParams?.schemaId ?? searchParams.get('schemaId');
  const defaultSchemaIdUserSetting = useUserSettingsSelector('defaultSchemaId');
  const activeSchemaIdUserSetting = useUserSettingsSelector('activeSchemaId');

  return useMemo(() => {
    const fallbackSchemas = [
      schemaIdFromUrl,
      activeSchemaIdUserSetting,
      defaultSchemaIdUserSetting,
      schemaConfig?.defaultSchemaId,
    ];

    for (const candidateId of fallbackSchemas) {
      if (!candidateId) {
        continue;
      }

      const schema = schemaConfig?.schemas.find((s) => s.id === candidateId);

      if (schema && !schema.disabled) {
        return candidateId;
      }
    }

    // if none of the fallback list is active return first active
    const firstActive = schemaConfig?.schemas.find((s) => !s.disabled);
    return firstActive?.id;
  }, [
    activeSchemaIdUserSetting,
    defaultSchemaIdUserSetting,
    schemaConfig?.defaultSchemaId,
    schemaConfig?.schemas,
    schemaIdFromUrl,
  ]);
};

export default useOptionalDefaultSchemaId;
